import React from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { useSanitizeFinance } from '../../context/SanitizeFinanceContext';

const SanitizeFinanceButton: React.FC = () => {
  const { enabled, toggle } = useSanitizeFinance();
  const label = enabled ? 'Show financials' : 'Hide financials';

  return (
    <button
      type="button"
      className={`agent-activity-bell${enabled ? ' active' : ''}`}
      title={label}
      aria-label={label}
      aria-pressed={enabled}
      onClick={toggle}
    >
      {enabled ? <Eye size={20} aria-hidden /> : <EyeOff size={20} aria-hidden />}
    </button>
  );
};

export default SanitizeFinanceButton;
